export const globalScriptMixin = {
	mounted() {
		// Code that will run only after the
		// entire view has been rendered
		this.$nextTick(function () {
			// Code  here apply in every component each time you made an action
			// Toggle the side navigation
			const sidebarToggle = document.querySelector('#sidebarToggle');
			const sidebarNotLoggedIn = document.querySelector('#sidebarNotLoggedIn');
			
			if (sidebarToggle) {
				document.querySelector("#sidebarToggle").addEventListener("click", function (e) {
					e.preventDefault();
					document.body.classList.toggle("sidenav-toggled");
				});
				// if(sidebarNotLoggedIn)
				// 	document.body.classList.toggle("sidenav-toggled");

			}

			// Click to collapse responsive sidebar
			const BODY = document.body
			const layoutSidenavContent = document.querySelector("#layoutSidenav_content")
			if(layoutSidenavContent) {
				layoutSidenavContent.addEventListener("click", function () {
					const BOOTSTRAP_LG_WIDTH = 992;
					if (window.innerWidth >= BOOTSTRAP_LG_WIDTH) {
						return;
					}
					if (BODY && BODY.classList) {
						if (BODY.classList.contains('sidenav-toggled')) {
							BODY.classList.toggle('sidenav-toggled');
						}
					}
				});
			}

			// Init sidebar
			let activatedPath = window.location.pathname;
			let baseAppUrl = process.env.VUE_APP_BASE_URL || null
			if (!activatedPath) {
				if(baseAppUrl && baseAppUrl !== "") {
					activatedPath = '/dashboard';
				} 
				else {
					activatedPath = '/' + baseAppUrl + '/dashboard';
				}
			}

			let targetAnchor = document.querySelector('a[href="' + activatedPath + '"]');
			let collapseAncestors = this.getAncestorBySelector(targetAnchor, '.collapse');

			if(targetAnchor) {
				targetAnchor.classList.add('active');
			}
			collapseAncestors.forEach(function(element) {
				element.classList.add('show');
				if(document.querySelector('[data-target="#' + element.id + '"]') != null)
					document.querySelector('[data-target="#' + element.id + '"]').classList.remove('collapsed');
			});

		});
	},
	methods: {
		// Copied from : https://gomakethings.com/how-to-get-all-parent-elements-with-vanilla-javascript/#1-get-all-parents
		getAncestorBySelector(elem, selector) {
			// Element.matches() polyfill
			if (!Element.prototype.matches) {
				Element.prototype.matches = Element.prototype.matchesSelector ||
					Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector ||
					Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function(s) {
						var matches = (this.document || this.ownerDocument).querySelectorAll(s),
							i = matches.length;
						while (--i >= 0 && matches.item(i) !== this) {
							// Test
						}
						return i > -1;
					};
			}

			// Set up a parent array
			var parents = [];

			// Push each parent element to the array
			for ( ; elem && elem !== document; elem = elem.parentNode ) {
				if (selector) {
					if (elem.matches(selector)) {
						parents.push(elem);
					}
					continue;
				}
				parents.push(elem);
			}

			// Return our parent array
			return parents;
		}
	},
	destroyed() {
		if(document.querySelector("#sidebarToggle")) {
			document.querySelector("#sidebarToggle").removeEventListener("click", null);
		}
	}
}